module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"accountInfo":"Account Information","settings":"Settings"}}')
  delete Component.options._Ctor
}
